<template>
  <span class="slot" @click.stop="$emit('clickSlot')">
    <slot></slot>
  </span>
</template>

<script>
  export default {
    name: "slotTemp"
  }
</script>

<style lang="less" scoped>
  .slot {
    &:hover {
      /deep/ i {
        transform: scale(1.4) translateX(-5%);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// components/apply-menu-tree/slotTemp.vue